import forEach from "core/src/core/util/for-each.js";
import { asset } from "../../shared/portal-env";

// Absolute paths (leading "/") so they resolve from the site root no matter which
// route the renderer was first imported on (e.g. /online), not relative to it.
var POWERUP_IMAGE_URLS = {
    "clear": asset("/svg/powerup/clear.svg"),
    "drunk": asset("/svg/powerup/drunk.svg"),
    "fat": asset("/svg/powerup/fat.svg"),
    "slim": asset("/svg/powerup/slim.svg"),
    "slow": asset("/svg/powerup/slow.svg"),
    "slow_turn": asset("/svg/powerup/slowturn.svg"),
    "speed": asset("/svg/powerup/speed.svg"),
    "super_jump": asset("/svg/powerup/superjump.svg"),
    "switcharoonie": asset("/svg/powerup/switcharoonie.svg"),
    "key_switch": asset("/svg/powerup/switchkeys.svg"),
    "tron_turn": asset("/svg/powerup/tronturn.svg"),
    "quick_turn": asset("/svg/powerup/quickturn.svg"),
    "twin": asset("/svg/powerup/twin.svg"),
    "wall_hack": asset("/svg/powerup/wallhack.svg")
};
var imageElements = {};

forEach(POWERUP_IMAGE_URLS, (svgPath,key) => {
    var imageElement = document.createElement("img");
    imageElement.src = svgPath;
    imageElements[key] = imageElement;
});

function getPowerUpImage(name) {
    return imageElements[name];
}

export {
    getPowerUpImage
};